import React, { useState } from "react";
import axios from "axios";
import "./ForgotPasswordForm.css";
const API_URL = process.env.REACT_APP_API_URL;

const ResetPasswordForm = ({ email, onBack, onSuccess }) => {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        `${API_URL}/api/auth/reset-password`,
        { email, otp, newPassword }
      );

      if (res.status === 200) {
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-component-container">
      <div className="auth-wrapper">
        <div className="background-shape" />

        <div className="welcome-section">
          <h2>NEW PASSWORD</h2>
        </div>

        <div className="credentials-panel">
          <h3>Reset Password</h3>
          <p className="subtext">Enter OTP and your new password.</p>

          <form onSubmit={handleReset}>
            <input className="field-input" type="email" value={email} readOnly />

            <input
              className="field-input"
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />

            <input
              className="field-input"
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />

            {error && <p className="error-text">{error}</p>}

            <button type="submit" disabled={loading} className="action-button">
              {loading ? "Resetting..." : "Reset Password"}
            </button>

            <button type="button" onClick={onBack} className="back-button">
              Back
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
 